import { useState } from "react";

import { Image } from "@chakra-ui/react";

import {
  type AppIconName,
  Icon,
} from "@shared/ui/chakra/data-display/icon/icon";

const logoIcons: AppIconName[] = [
  "CryptoOther",
  "PaymentElqr",
  "PaymentSbp",
  "PaymentVtbQr",
];

type Props = {
  logoImage?: null | string;
  name: AppIconName;
};

export const PaymentSystemIcon = ({ logoImage, name }: Props) => {
  const [brokenLogo, setBrokenLogo] = useState<null | string>(null);

  if (logoImage && logoImage !== brokenLogo) {
    return (
      <Image
        alt=""
        borderRadius="full"
        boxSize="40px"
        flexShrink={0}
        src={logoImage}
        onError={() => setBrokenLogo(logoImage)}
      />
    );
  }

  return logoIcons.includes(name) ? (
    <Icon boxSize="40px" name={name} />
  ) : (
    <Icon boxSize="24px" color="fg.accent" name={name} variant="frame" />
  );
};
